<template>
  <!-- eslint-disable  -->
  <form class="px-3 mb-4 force-bind-modal" v-on:submit.prevent="submitBundleForceBind" action="self">
    <hr />
    <input-product-type :insuranceType="formFields.insuranceType"></input-product-type>
    <div class="row" v-show="formFields.insuranceType.field_value !== ''">
      <div :class="{ 'col-6': halfLayout, 'col-12': !halfLayout, 'disabled': isHomeBound }" v-show="showPropertySection">
        <h1>{{ flow }} Policy</h1>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.forceBindCarrier.field_name)">
          <div class="col">
            <label>Binding Carrier <span class="required-red">*</span></label>
            <div class="form-group">
              <div class="btn-group btn-group-toggle  w-auto smaller-font-content" data-toggle="buttons" tabindex="-1">
                <v-select class=" w-auto" :options="carriers"
                  v-bind:class="{ 'std-width form-control': false, 'error': formErrors.includes(formFields.forceBindCarrier.field_name) }"
                  label="carrier_name" :name="formFields.forceBindCarrier.field_name"
                  :id="formFields.forceBindCarrier.field_name" :ref="formFields.forceBindCarrier.field_name"
                  v-model="formFields.forceBindCarrier.field_value" size="auto" placeholder="Select One" :disabled="isHomeBound"/>
              </div>
              <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.forceBindCarrier.field_name) }"></i>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.policyNumber.field_name)">
          <div class="col">
            <label>Policy Number<span class="required-red">*</span></label>
            <div class="form-group">
              <div class="input-group">
                <input type="text"
                  v-bind:class="{ 'form-control': true, 'error': formErrors.includes(formFields.policyNumber.field_name)}" maxlength="20"
                  v-model="formFields.policyNumber.field_value" :disabled="isHomeBound">
                <i
                  v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.policyNumber.field_name) }"></i>
              </div>
              <div class="field-subtext pr-2">
                <div class="form-text smaller-font-content">20 Character Maximum</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.finalPremium.field_name)">
          <div class="col">
            <label>Total Premium<span class="required-red">*</span></label>
            <div class="form-group">
              <div class="input-group">
                <money v-model="formFields.finalPremium.field_value" v-bind="money" maxlength="9"
                  v-bind:class="{ 'form-control': true, 'error': formErrors.includes(formFields.finalPremium.field_name) }" :disabled="isHomeBound">
                </money>
                <i
                  v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.finalPremium.field_name) }"></i>
              </div>
              <div class="field-subtext pr-2">
                <div class="form-text smaller-font-content">7 Digit Maximum ($XXXXX.XX)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.effectiveDate.field_name)">
          <div class="col">
            <label>Policy Effective Date<span class="required-red">*</span></label>
            <div class="form-group">
              <div class="input-group">
                <datepicker 
                  v-model="formFields.effectiveDate.field_value" 
                  :bootstrap-styling="true" 
                  :typeable="true" 
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY" 
                  style="width:6rem;" 
                  :input-class="{ 'error': formErrors.includes(formFields.effectiveDate.field_name) }"
                  @opened="clearDateErrors()" 
                  :disabled="isHomeBound">
                </datepicker>
                <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.effectiveDate.field_name) }"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="{ 'col-6': halfLayout, 'col-12': !halfLayout, 'disabled': isAutoBound }" v-show="showAutoSection">
        <h1>Auto Policy</h1>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.forceBindCarrierAuto.field_name)">
          <div class="col">
            <label>Binding Carrier <span class="required-red">*</span></label>
            <div class="form-group">
              <div class="btn-group btn-group-toggle  w-auto smaller-font-content" data-toggle="buttons" tabindex="-1">
                <v-select class=" w-auto" :options="autoCarriers"
                  v-bind:class="{ 'std-width form-control': false, 'error': formErrors.includes(formFields.forceBindCarrierAuto.field_name) }"
                  label="carrier_name" :name="formFields.forceBindCarrierAuto.field_name"
                  :id="formFields.forceBindCarrierAuto.field_name" :ref="formFields.forceBindCarrierAuto.field_name"
                  v-model="formFields.forceBindCarrierAuto.field_value" size="auto" placeholder="Select One" :disabled="isAutoBound"/>
              </div>
              <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.forceBindCarrierAuto.field_name) }"></i>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.policyNumberAuto.field_name)">
          <div class="col">
            <label>Policy Number<span class="required-red">*</span></label>
            <div class="form-group">
              <div class="input-group">
                <input type="text"
                  v-bind:class="{ 'form-control': true, 'error': formErrors.includes(formFields.policyNumberAuto.field_name)}" maxlength="20"
                  v-model="formFields.policyNumberAuto.field_value" :disabled="isAutoBound">
                <i
                  v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.policyNumberAuto.field_name) }"></i>
              </div>
              <div class="field-subtext pr-2">
                <div class="form-text smaller-font-content">20 Character Maximum</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.finalPremiumAuto.field_name)">
          <div class="col">
            <label>Total Premium<span class="required-red">*</span></label>
            <div class="form-group">
              <div class="input-group">
                <money v-model="formFields.finalPremiumAuto.field_value" v-bind="money" maxlength="9"
                  v-bind:class="{ 'form-control': true, 'error': formErrors.includes(formFields.finalPremiumAuto.field_name) }" :disabled="isAutoBound">
                </money>
                <i
                  v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.finalPremiumAuto.field_name) }"></i>
              </div>
              <div class="field-subtext pr-2">
                <div class="form-text smaller-font-content">7 Digit Maximum ($XXXXX.XX)</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.termLength.field_name)">
          <div class="col">
            <div class="form-group">
              <div><label>Policy Term<span class="required-red">*</span></label></div>
              <div class="input-group field-input-radio">
                <div data-toggle="buttons" class="btn-group btn-group-toggle" :class="{'error': formErrors.includes(formFields.termLength.field_name) }" :disabled="isAutoBound">
                  <div class="btn btn-outline-light" :class="{'active': formFields.termLength.field_value === '12Month' ? true : false,}">
                    <input 
                      name="termLength" 
                      v-model="formFields.termLength.field_value" 
                      id="term-12-mo-radio" 
                      type="radio"
                      value="12Month" :disabled="isAutoBound">
                    <label class="cursorBox" for="term-12-mo-radio">12 months</label>
                  </div>
                  <div class="btn btn-outline-light" :class="{'active': formFields.termLength.field_value === '6Month' ? true : false,}">
                    <input 
                      name="termLength" 
                      v-model="formFields.termLength.field_value" 
                      id="term-6-mo-radio" 
                      type="radio"
                      value="6Month" :disabled="isAutoBound">
                    <label class="cursorBox" for="term-6-mo-radio">6 months</label>
                  </div>
                </div>
                <i v-bind:class="{'warning fas fa-exclamation-triangle': formErrors.includes(formFields.termLength.field_name) }"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters" @mousedown.capture="clearMessages(formFields.effectiveDateAuto.field_name)">
          <div class="col">
            <label>Policy Effective Date<span class="required-red">*</span></label>
            <div class="form-group">
              <div class="input-group">
                <datepicker 
                  v-model="formFields.effectiveDateAuto.field_value" 
                  :bootstrap-styling="true" 
                  :typeable="true" 
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY" 
                  style="width:6rem;" 
                  :input-class="{ 'error': formErrors.includes(formFields.effectiveDateAuto.field_name) }"
                  @opened="clearDateErrors()" 
                  :disabled="isAutoBound">
                </datepicker>
                <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.includes(formFields.effectiveDateAuto.field_name) }"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <!-- CONFIRM & CONSENT NOTICE -->
    <div class="d-block justify-content-center mx-auto my-3">
      <div class="alert alert-warning mx-3 my-0 py-2" role="alert">
        <div class="row no-gutters">
          <div class="d-inline-block pr-2 my-auto">
            <img width="25px" height="25px" src="../../assets/exclamation-circle-yellow-new.svg" alt="info">
          </div>
          <div class="col smaller-font-content d-inline-block my-auto">
            <p class="mb-0">Advise the customer of the next steps including that they must sign the application to
              avoid a premium increase or cancellation.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- CONFIRM & CONSENT NOTICE -->
    <button type="submit" v-if="namedInsuredStatus()" id="force-bind-submit-button"
      class="btn btn-primary d-block mx-auto">Force Bind Policy</button>
  </form>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import QRP from '../../../config/QRP.env';
import filters from '../../../config/admin/filters';
import InputProductType from '../interactive/InputProductType';
import postData from '../../services/postData';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['carriers', 'autoCarriers', 'namedInsuredStatus'],
  data() {
    return {
      formFields: {
        insuranceType: {
          field_name: 'insurance_type',
          label: 'Product',
          field_value: '',
          rules: [],
          field_type: 'text',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
          isForceBindModal: true,
        },
        forceBindCarrier: {
          field_name: 'force-bind-carrier-select',
          label: 'Binding Carrier',
          field_value: '',
          rules: [],
          field_type: 'select',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
        policyNumber: {
          field_name: 'policyNumber',
          label: 'Policy Number',
          field_value: '',
          rules: [],
          field_type: 'text',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
        finalPremium: {
          field_name: 'finalPremium',
          label: 'Total Premium',
          field_value: '',
          rules: [],
          field_type: 'money',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
        effectiveDate: {
          field_name: 'effectiveDate',
          label: 'Policy Effective Date',
          field_value: '',
          rules: [],
          field_type: 'date',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
        forceBindCarrierAuto: {
          field_name: 'force-bind-carrier-select-auto',
          label: 'Binding Carrier',
          field_value: '',
          rules: [],
          field_type: 'select',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
        policyNumberAuto: {
          field_name: 'policyNumberAuto',
          label: 'Policy Number',
          field_value: '',
          rules: [],
          field_type: 'text',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
        finalPremiumAuto: {
          field_name: 'finalPremiumAuto',
          label: 'Total Premium',
          field_value: '',
          rules: [],
          field_type: 'money',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
        effectiveDateAuto: {
          field_name: 'effectiveDateAuto',
          label: 'Policy Effective Date',
          field_value: '',
          rules: [],
          field_type: 'date',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
        termLength: {
          field_name: 'termLength',
          label: 'Policy Term',
          field_value: '',
          rules: [],
          field_type: 'radio',
          help_text: '',
          values: [],
          is_required: true,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
          multi_select: false,
        },
      },
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
      },
      selectedCarrier: '',
      flowType: '',
      flow: '',
      showAutoSection: false,
      showPropertySection: false,
      formErrors: [],
    };
  },
  components: {
    vSelect,
    Datepicker,
    InputProductType,
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
    this.flow = 'Home';
    if (this.flowType === 'cabundle') {
      this.flow = 'Condo';
    } else if (this.flowType === 'rabundle') {
      this.flow = 'Renters';
    }
  },
  mounted() {
    let productAccess = JSON.parse(sessionStorage.getItem('productAccess'));
    //Added logic to hide product if flow is bind for that product
    if (productAccess.includes(QRP.PRODUCTS.AUTO) && sessionStorage.getItem('autobound') == 'true') { 
      const index = productAccess.indexOf(QRP.PRODUCTS.AUTO);
      if (index > -1) {
        productAccess.splice(index, 1);
      }
    } 
    if (this.flowType === 'bundle' && productAccess.includes(QRP.PRODUCTS.HOME) && sessionStorage.getItem('homebound') == 'true') { 
      const index = productAccess.indexOf(QRP.PRODUCTS.HOME);
      if (index > -1) {
        productAccess.splice(index, 1);
      }
    } else if (this.flowType === 'cabundle' && productAccess.includes(QRP.PRODUCTS.CONDO) && sessionStorage.getItem('homebound') == 'true') {
      const index = productAccess.indexOf(QRP.PRODUCTS.CONDO);
      console.log("index", index);
      if (index > -1) {
        productAccess.splice(index, 1);
      }
    } else if (this.flowType === 'rabundle' && productAccess.includes(QRP.PRODUCTS.RENTERS) && sessionStorage.getItem('homebound') == 'true') { 
      const index = productAccess.indexOf(QRP.PRODUCTS.RENTERS);
      if (index > -1) {
        productAccess.splice(index, 1);
      }
    }
    this.productButtonsData = Object.create(this.formFields.insuranceType);
    let productOrder;
    if (this.flowType === 'bundle') {
      productOrder = [QRP.PRODUCTS.AUTO, QRP.PRODUCTS.HOME, QRP.PRODUCTS.HA_BUNDLE];
    } else if (this.flowType === 'cabundle') {
      productOrder = [QRP.PRODUCTS.AUTO, QRP.PRODUCTS.CONDO, QRP.PRODUCTS.CA_BUNDLE];
    } else if (this.flowType === 'rabundle') {
      productOrder = [QRP.PRODUCTS.AUTO, QRP.PRODUCTS.RENTERS, QRP.PRODUCTS.RA_BUNDLE];
    }
    // , QRP.PRODUCTS.HA_BUNDLE, QRP.PRODUCTS.CA_BUNDLE, QRP.PRODUCTS.RA_BUNDLE];
    if (productAccess.includes(QRP.PRODUCTS.AUTO) && productAccess.includes(QRP.PRODUCTS.HOME)) {
      productAccess.push(QRP.PRODUCTS.HA_BUNDLE);//TODO
    }
    if (productAccess.includes(QRP.PRODUCTS.CONDO) && productAccess.includes(QRP.PRODUCTS.AUTO)) {
      productAccess.push(QRP.PRODUCTS.CA_BUNDLE);//TODO
    }
    if (productAccess.includes(QRP.PRODUCTS.RENTERS) && productAccess.includes(QRP.PRODUCTS.AUTO)) {
      productAccess.push(QRP.PRODUCTS.RA_BUNDLE);//TODO
    }
    if (typeof productAccess === 'object') {
      for (let i = 0; i < productOrder.length; i += 1) {
        if (productAccess.includes(productOrder[i])) {
          this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
        }
      }
    } else {
      const productAccessArray = productAccess.split(',');

      for (let i = 0; i < productOrder.length; i += 1) {
        if (productAccessArray.includes(productOrder[i])) {
          this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
        }
      }
    }

    if (productAccess.length === 1) {
      this.productButtonsData.field_value = productAccess[0]; // the single product is set as the selected one
    }

    this.formFields.insuranceType = [];
    this.formFields.insuranceType = this.productButtonsData;
    console.log("this.formFields.insuranceType",this.formFields.insuranceType);
  },
  computed: {
    isHomeBound() {
      return sessionStorage.getItem('homebound') == 'true';
    },
    isAutoBound() {
      return sessionStorage.getItem('autobound') == 'true';
    },
    isBtnDisabled() {
      return this.formFields.insuranceType.field_value === '';
    },
    halfLayout() {
      if (this.flowType !== 'bundle' && this.flowType !== 'cabundle' && this.flowType !== 'rabundle') {
        return false;
      }
      return true;
    },
  },
  methods: {
    checkForceBindForm() {
      this.formErrors = [];
      if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.HOME || this.formFields.insuranceType.field_value === QRP.PRODUCTS.CONDO || this.formFields.insuranceType.field_value === QRP.PRODUCTS.RENTERS) {
        if (!this.isHomeBound) {
          if (this.formFields.forceBindCarrier.field_value && this.formFields.policyNumber.field_value && this.formFields.finalPremium.field_value && this.formFields.effectiveDate.field_value) {
            return true;
          }
          if (!this.formFields.forceBindCarrier.field_value) {
            this.formErrors.push(this.formFields.forceBindCarrier.field_name);
          }
          if (!this.formFields.policyNumber.field_value) {
            this.formErrors.push(this.formFields.policyNumber.field_name);
          }
          if (!this.formFields.finalPremium.field_value) {
            this.formErrors.push(this.formFields.finalPremium.field_name);
          }
          if (!this.formFields.effectiveDate.field_value) {
            this.formErrors.push(this.formFields.effectiveDate.field_name);
          }
        }
      } else if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.AUTO) {
        if (!this.isAutoBound) {
          if (this.formFields.forceBindCarrierAuto.field_value && this.formFields.policyNumberAuto.field_value && this.formFields.finalPremiumAuto.field_value && this.formFields.termLength.field_value && this.formFields.effectiveDateAuto.field_value) {
            return true;
          }
          if (!this.formFields.forceBindCarrierAuto.field_value) {
            this.formErrors.push(this.formFields.forceBindCarrierAuto.field_name);
          }
          if (!this.formFields.policyNumberAuto.field_value) {
            this.formErrors.push(this.formFields.policyNumberAuto.field_name);
          }
          if (!this.formFields.finalPremiumAuto.field_value) {
            this.formErrors.push(this.formFields.finalPremiumAuto.field_name);
          }
          if (!this.formFields.termLength.field_value) {
            this.formErrors.push(this.formFields.termLength.field_name);
          }
          if (!this.formFields.effectiveDateAuto.field_value) {
            this.formErrors.push(this.formFields.effectiveDateAuto.field_name);
          }
        }
      } else if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE || this.formFields.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE || this.formFields.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {        
        if (this.formFields.forceBindCarrier.field_value && this.formFields.policyNumber.field_value && this.formFields.finalPremium.field_value && this.formFields.effectiveDate.field_value && this.formFields.forceBindCarrierAuto.field_value && this.formFields.policyNumberAuto.field_value && this.formFields.finalPremiumAuto.field_value && this.formFields.termLength.field_value && this.formFields.effectiveDateAuto.field_value) {
          return true;
        }
        if (!this.isHomeBound) {
          if (!this.formFields.forceBindCarrier.field_value) {
            this.formErrors.push(this.formFields.forceBindCarrier.field_name);
          }
          if (!this.formFields.policyNumber.field_value) {
            this.formErrors.push(this.formFields.policyNumber.field_name);
          }
          if (!this.formFields.finalPremium.field_value) {
            this.formErrors.push(this.formFields.finalPremium.field_name);
          }
          if (!this.formFields.effectiveDate.field_value) {
            this.formErrors.push(this.formFields.effectiveDate.field_name);
          }
        }
        if (!this.isAutoBound) {
          if (!this.formFields.forceBindCarrierAuto.field_value) {
            this.formErrors.push(this.formFields.forceBindCarrierAuto.field_name);
          }
          if (!this.formFields.policyNumberAuto.field_value) {
            this.formErrors.push(this.formFields.policyNumberAuto.field_name);
          }
          if (!this.formFields.finalPremiumAuto.field_value) {
            this.formErrors.push(this.formFields.finalPremiumAuto.field_name);
          }
          if (!this.formFields.termLength.field_value) {
            this.formErrors.push(this.formFields.termLength.field_name);
          }
          if (!this.formFields.effectiveDateAuto.field_value) {
            this.formErrors.push(this.formFields.effectiveDateAuto.field_name);
          }
        }
      }      
      return false;
    },
    clearDateErrors() {
      this.formErrors.remove(this.formFields.effectiveDate.field_name);
    },
    clearMessages(fieldName) {
      const index = this.formErrors.indexOf(fieldName);
      if (index > -1) { // only splice array when item is found
        this.formErrors.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    submitBundleForceBind() {
      let CarrierId;
      let CarrierIdAuto;
      this.$validator.detach(this.formFields.insuranceType.field_name);
      this.$validator.attach({
        name: this.formFields.insuranceType.field_name,
        rules: 'required',
        getter: () => this.formFields.insuranceType.field_value,
      });
      this.$validator.validate(this.formFields.insuranceType.field_name).then(async (result) => {
        if (!result) {
          if (this.errors.has(this.formFields.insuranceType.field_name)) {
            document.getElementById('Auto').focus();
          }
          return;
        }
        //Check Validations
        let status = this.checkForceBindForm();
        if (status) {
          const forceBindSubmitButton = document.getElementById('force-bind-submit-button');
          forceBindSubmitButton.disabled = true;
          let response;
          let homeresponse;
          let HOQuoteId;
          let forceBindStatus = false;
          let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
          
          if (this.flowType === 'bundle') {
            HOQuoteId = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;        
          } else if (this.flowType === 'cabundle') {
            HOQuoteId = JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId;
          } else if (this.flowType === 'rabundle') {          
            HOQuoteId = JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId;
          }
          if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.HOME || this.formFields.insuranceType.field_value === QRP.PRODUCTS.CONDO || this.formFields.insuranceType.field_value === QRP.PRODUCTS.RENTERS) {
            if (!this.isHomeBound) {
              let finalDate = this.getFinalDate(this.formFields.effectiveDate.field_value);
              CarrierId = this.formFields.forceBindCarrier.field_value.carrier_id;
              
              let requestBody = {
                SessionId: HOQuoteId,
                CarrierId: CarrierId,
                PolicyNumber: this.formFields.policyNumber.field_value,
                Premium: this.formFields.finalPremium.field_value.toString(),
                PolicyEffectiveDate: finalDate,
              };
              homeresponse = await this.callForceBind(requestBody);
              if (homeresponse.status === 200 && homeresponse.statusText === 'OK') {
                sessionStorage.setItem('homebound', true);
                forceBindStatus = true;
              }
            } else {
              forceBindStatus = true;
            }
          } else if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.AUTO) {
            if (!this.isAutoBound) {
              let finalDateAuto = this.getFinalDate(this.formFields.effectiveDateAuto.field_value);
              CarrierIdAuto = this.formFields.forceBindCarrierAuto.field_value.carrier_id;

              let requestBodyAuto = {
                SessionId: AUQuoteId,
                CarrierId: CarrierIdAuto,
                PolicyNumber: this.formFields.policyNumberAuto.field_value,
                Premium: this.formFields.finalPremiumAuto.field_value.toString(),
                Term: this.formFields.termLength.field_value,
                PolicyEffectiveDate: finalDateAuto,
              };
              response = await this.callForceBind(requestBodyAuto);
              if (response.status === 200 && response.statusText === 'OK') {
                sessionStorage.setItem('autobound', true);
                forceBindStatus = true;
              }
            } else {
              forceBindStatus = true;
            }
          } else if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE || this.formFields.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE || this.formFields.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {
            //Call Property Force Bind
            if (!this.isHomeBound) {
              let finalDate = this.getFinalDate(this.formFields.effectiveDate.field_value);
              CarrierId = this.formFields.forceBindCarrier.field_value.carrier_id;
              let requestBody = {
                SessionId: HOQuoteId,
                CarrierId: CarrierId,
                PolicyNumber: this.formFields.policyNumber.field_value,
                Premium: this.formFields.finalPremium.field_value.toString(),
                PolicyEffectiveDate: finalDate,
              };
              homeresponse = await this.callForceBind(requestBody);
              if (homeresponse.status === 200 && homeresponse.statusText === 'OK') {
                sessionStorage.setItem('homebound', true);
              }
            }
            
            if (!this.isAutoBound) {
              //Call Auto Force Bind
              let finalDateAuto = this.getFinalDate(this.formFields.effectiveDateAuto.field_value);
              CarrierIdAuto = this.formFields.forceBindCarrierAuto.field_value.carrier_id;
              let requestBodyAuto = {
                SessionId: AUQuoteId,
                CarrierId: CarrierIdAuto,
                PolicyNumber: this.formFields.policyNumberAuto.field_value,
                Premium: this.formFields.finalPremiumAuto.field_value.toString(),
                Term: this.formFields.termLength.field_value,
                PolicyEffectiveDate: finalDateAuto,
              };
              response = await this.callForceBind(requestBodyAuto);
              if (response.status === 200 && response.statusText === 'OK') {
                sessionStorage.setItem('autobound', true);
                forceBindStatus = true;              
              }
            } else {
              forceBindStatus = true;
            }
          }
          if (forceBindStatus) {
            this.$modal.hide('force-bind-modal');
            this.$store.dispatch('setForceBindSuccessful');
            forceBindSubmitButton.disabled = false;
            let currentNav = sessionStorage.getItem('currentNav');
            if (currentNav === 'homerc2' || currentNav === 'autorc2' || currentNav === 'condorc2' || currentNav === 'rentersrc2' || currentNav === 'checkout') {
                sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
                let cuurentNav = '/pages/carriermatches/' + JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
                this.$store.dispatch('setCurrentNav', cuurentNav);
                //added delay because getting 500 to page api when it redirected to carrier match
                setTimeout(() => {
                  this.$router.push('/auto/carrier-matches');
                }, 500);
              } else {
              setTimeout(() => {
                location.reload();
              }, 500);
            }
          }
        }
      });
    },
    async callForceBind(requestBody) {
      let bindResponse = {};
      const url = '/autoquotes/forcebind';
      await postData.submitForceBind(url, requestBody).then(async (response) => {
        if (response.status === 200 && response.statusText === 'OK') {
          bindResponse =  response;
        }
      }).catch((error) => {
        const forceBindSubmitButton = document.getElementById('force-bind-submit-button');
        this.formErrors.general = error.response.data.Message;
        forceBindSubmitButton.disabled = false;
      });
      return bindResponse;
    },
    
    getFinalDate(effectiveDate) {
      console.log('effectiveDate', effectiveDate);
      const year = effectiveDate.getFullYear();
      // make sure that month and date are prepended with 0 if a single digit number
      const month = `0${effectiveDate.getMonth() + 1}`.slice(-2);
      const day = `0${effectiveDate.getDate()}`.slice(-2);
      return `${year}${month}${day}`;
    },
      
    /**
     * check named insured tab status to show/hide submit button
     */
    //  namedInsuredStatus() {
    //   const tabData = this.$store.state.buttonState.buttonsData || [];

    //   for (let tCnt = 0; tCnt <= tabData.length; tCnt += 1) {
    //     if (tabData[tCnt] && tabData[tCnt].name && tabData[tCnt].name.includes('NamedInsured')) {
    //       if (tabData[tCnt].status === 'ActiveComplete' || tabData[tCnt].status === 'InactiveComplete') {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
  },
  watch: {
    'formFields.insuranceType.field_value': function () {
      this.formErrors = [];
      if (this.formFields.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE || this.formFields.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE || this.formFields.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {
        this.showAutoSection = true;
        this.showPropertySection = true;
      } else if ((this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') && this.formFields.insuranceType.field_value == QRP.PRODUCTS.AUTO) {
        this.showAutoSection = true;
        this.showPropertySection = false;
      } else {
        this.showAutoSection = false;
        this.showPropertySection = this.formFields.insuranceType.field_value !== '';
      }
    },
  },
};
</script>
<style lang="scss">
  .force-bind-modal {
    .switch-box-type:not(.home-auto-bundle):not(.condo-auto-bundle):not(.renter-auto-bundle) {
      width: 50% !important;
    }
    .btn-group>.btn:nth-child(2):not(.dropdown-toggle), .btn-group>.btn-group:nth-child(2)>.btn {
      border-top-right-radius: 0.25rem !important;
      border-bottom-right-radius: 0.25rem !important;
    }
    .required-red {
      color: #FF4400;
    }

    .w-auto {
      width: auto !important;
    }

    label {
      display: inline-block;
      margin-bottom: 0.125rem;
      font-size: 0.75rem;
      line-height: 1.25rem;
      font-weight: 600;
    }
    .btn-group.btn-group-toggle .btn {
      padding: 0.1875rem 1.5rem 0;
    }

    .btn-outline-light {
      color: #333333;
      background-color: transparent;
      background-image: none;
      border-color: #ced4da;
    }

    .btn-outline-light:not(:disabled):not(.disabled):active,
    .btn-outline-light:not(:disabled):not(.disabled).active,
    .show>.btn-outline-light.dropdown-toggle {
      color: #FFFFFF;
      background-color: #003366;
      border-color: #003366;
    }

    .btn-group-toggle>.btn input[type=radio],
    .btn-group-toggle>.btn input[type=checkbox],
    .btn-group-toggle>.btn-group>.btn input[type=radio],
    .btn-group-toggle>.btn-group>.btn input[type=checkbox] {
      position: absolute;
      clip: rect(0, 0, 0, 0);
      pointer-events: none;
    }

    input[type=radio],
    input[type=checkbox] {
      box-sizing: border-box;
      padding: 0;
    }
    .form-group {
      .text-danger {
        color: #BB0000 !important;
        background-color: transparent !important;
        padding: 0;
      }
    }
    .disabled {
      input, label {
        cursor: not-allowed;
        color: #ccc !important
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BundleForceBindModal.vue?610e36c8